export { default } from './IconClose';
